var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-date-picker',{staticStyle:{"width":"100%"},attrs:{"disabled":_vm.disabled,"type":"date","value-format":"yyyy-MM-dd","placeholder":"選擇日期"},on:{"change":_vm.valueChange},model:{value:(_vm.dataValue),callback:function ($$v) {_vm.dataValue=$$v},expression:"dataValue"}})
}
var staticRenderFns = []

export { render, staticRenderFns }